import { render, staticRenderFns } from "./progressive-profile-secondary-actions-step.vue?vue&type=template&id=251e9f84"
import script from "./progressive-profile-secondary-actions-step.vue?vue&type=script&lang=js"
export * from "./progressive-profile-secondary-actions-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports